import { useState } from 'react'
import { Link } from "react-router-dom"
import '../css/admin.css'
import { Cargando } from '../Cargando'
import { AuthServices } from '../util/authServices'

const LoginAdmin = ({ setUserSession, toast }) => {

    const [cargando, setCargando] = useState(false)
    const [actualizaPassView, setActualizaPassView] = useState(false)

    const [loginElements, setLoginElements] = useState({
        usuario: '',
        contrasenia: '',
        newContrasenia: '',
        confimaContrasenia: ''
    })

    const { usuario, contrasenia, newContrasenia, confimaContrasenia } = loginElements

    const inputEvent = (e) => {
        if (e.target.name === 'usuario') {
            setLoginElements({
                ...loginElements,
                'usuario': e.target.value
            })
        } else if (e.target.name === 'contrasenia') {
            setLoginElements({
                ...loginElements,
                'contrasenia': e.target.value
            })
        } else if (e.target.name === 'newContrasenia') {
            setLoginElements({
                ...loginElements,
                'newContrasenia': e.target.value
            })
        } else if (e.target.name === 'confimaContrasenia') {
            setLoginElements({
                ...loginElements,
                'confimaContrasenia': e.target.value
            })
        }
    }

    const clickLogin = () => {
        loginActionApp();
    }

    const clickActualizaPass = () => {
        if (newContrasenia.length > 5) {
            if (newContrasenia === confimaContrasenia) {
                actualizaActionApp()
            } else {
                toast("Las contraseñas no son iguales")
            }
        } else {
            toast("Su contraseña debe tener minimo 6 caracteres")
        }
    }

    const cancelaActualizarPass = () => {
        setActualizaPassView(false)
        setLoginElements({
            usuario: '',
            contrasenia: '',
            newContrasenia: '',
            confimaContrasenia: ''
        })
    }

    const actualizaActionApp = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "usuario": usuario,
                "newContrasenia": newContrasenia
            }
            const response = await authServices.requestPost(body, 13);
            const { estado, mensaje } = response.data;
            if (estado) {
                setActualizaPassView(false)
                setLoginElements({
                    ...loginElements,
                    'contrasenia': '',
                    'newContrasenia': '',
                    'confimaContrasenia': ''
                })
            }
            setCargando(false);
            toast(mensaje)
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    const loginActionApp = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "usuario": usuario,
                "contrasenia": contrasenia
            }
            const response = await authServices.requestPost(body, 14);
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                if (objeto.activo) {
                    setUserSession({
                        nombre: objeto.nombre,
                        apellido: objeto.apellido,
                        usuario: objeto.usuario,
                        role: objeto.role
                    })
                    sessionStorage.setItem('userSessionStorage', JSON.stringify({
                        nombre: objeto.nombre,
                        apellido: objeto.apellido,
                        usuario: objeto.usuario,
                        role: objeto.role
                    }))
                } else {
                    setActualizaPassView(true)
                }
            } else {
                toast(mensaje)
            }
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    return (
        <div className='div-admin-principal'>
            <div className='div-target-login'>
                {
                    actualizaPassView ?
                        <>
                            <div className='div-elements-children' >
                                <h3 className='titulo-login'>Actualiza Password</h3>
                                <div className='div-inputs-login'>
                                    <p className='p-label-form'> Nueva contraseña </p>
                                    <input type="password" name='newContrasenia' value={newContrasenia} onChange={inputEvent} className='form-control' autoComplete='off' />
                                </div>
                                <div className='div-inputs-login'>
                                    <p className='p-label-form'> Confirmar contraseña </p>
                                    <input type="password" name='confimaContrasenia' value={confimaContrasenia} onChange={inputEvent} className='form-control' autoComplete='off' />
                                </div>
                                <div className='div-bottom-custom-login mt-4'>
                                    <button className='btn btn-link' onClick={() => cancelaActualizarPass()} >
                                        Volver
                                    </button>
                                    <button className='btn btn-primary custom-btn' onClick={() => clickActualizaPass()} >
                                        Actualizar
                                    </button>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <div className='div-elements-children' >
                                <h3 className='titulo-login'>Login Ifernal Paradise</h3>
                                <div className='div-inputs-login'>
                                    <p className='p-label-form'> Usuario </p>
                                    <input type="text" name='usuario' value={usuario} onChange={inputEvent} className='form-control' placeholder='Usuario' autoComplete='off' />
                                </div>
                                <div className='div-inputs-login'>
                                    <p className='p-label-form'> Contraseña </p>
                                    <input type="password" name='contrasenia' value={contrasenia} onChange={inputEvent} className='form-control' placeholder='Contraseña' autoComplete='off' />
                                </div>
                                <div className='div-bottom-custom-login mt-4'>
                                    <Link className='btn btn-link' to="/">Ir a sitio</Link>
                                    <button className='btn btn-primary custom-btn' onClick={() => clickLogin()} >
                                        Ingresar
                                    </button>
                                </div>
                            </div>
                        </>
                }
                <p className='p-info-login'>dgc-software | Todos los derechos reservados </p>
            </div>
            {
                cargando ?
                    <Cargando />
                    :
                    <></>
            }
        </div>
    )
}

export default LoginAdmin